module.exports = __webpack_public_path__ + "img/LocumWallet logo_blue.71cf6ef3.png";